function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 74.5 39.81"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M25 0h24.49a25 25 0 0 1 25 25v10.82a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V25A25 25 0 0 1 25 0Z",
  style: {
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.2,
    isolation: "isolate"
  }
}));
export { SvgBack as ReactComponent };
export default __webpack_public_path__ + "static/media/back.8607cc17.svg";